// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul[data-v-12ed3304] {\n  width: 100%;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}", ""]);
// Exports
module.exports = exports;
